<template>
  <div class='box'>
    <div style="padding: 32px 0 32px 0;">
      <span style="font-size:14px;color:#999999;">
        您的位置：
        <span style='color:#999999;cursor: pointer;' @click="toHome">首页></span>
        <span style="color:#999999;cursor: pointer;" @click="toEqment">仪器设备></span>
        <span style="color:#188335">预约中心</span>
      </span>
    </div>
    <!-- <div class='card_header'>
      预约申请
    </div> -->
    <el-tabs type="border-card" v-model="activeIndex" :before-leave="handleClick">
      <el-tab-pane v-if='examination_show' label="准入考试" name='1'>
        <admissionExamination v-if="activeIndex == '1'" :examinationData='examinationData' @submitExamination='init'>
        </admissionExamination>
      </el-tab-pane>
      <el-tab-pane v-if='eqExamination_show' label="设备专属考试" name='2'>
        <eqadmissionExamination v-if="activeIndex == '2'" :eqexaminationData='eqexaminationData' @submitExamination='init'
          :eqId='eqId'>
        </eqadmissionExamination>
      </el-tab-pane>
      <el-tab-pane label="填写预约信息" name='3'>
        <div class='appointment_card'>
          <div class='samalltitle titleBorder'>
            基本信息
          </div>
          <div class='samalltitle' style='padding:0 0 8px 16px'>
            设备图片
            <el-image style='width: 200px;height: 200px;vertical-align:top' v-if='formData.thumbnailPath'
              :src="baseurl + '/' + formData.thumbnailPath" :preview-src-list="showurlList">
            </el-image>
            <img v-else style='width: 292px;height: 180px; vertical-align:top' src="../../../assets/images/img_blank.png">
          </div>
          <div class='samalltitle titleBorder'>
            设备信息
          </div>
          <el-form ref="formData" :model="formData" label-width="36%" :inline="true" class='longForm'>
            <el-row style='margin-top:20px;border-bottom: 1px solid #D7DCE0;padding-bottom:48px'>
              <el-col :span='12'>
                <el-form-item label="设备编号">
                  <el-input disabled placeholder="设备编号" v-model="formData.equipmentNumber"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label="设备名称">
                  <el-input disabled placeholder="设备名称" v-model="formData.equipmentName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <el-form-item label="预约提示信息" label-width="15%">
                  <el-input disabled type='textarea' placeholder="预约提示信息" :rows='3' v-model="formData.remarks"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class='samalltitle titleBorder'>
            预约信息
          </div>
          <el-form ref="formDatas" :model="formDatas" label-width="36%" :inline="true" class='longForm' :rules="rules">
            <el-row style='margin-top:20px;padding-bottom:10px'>
              <el-col :span='12'>
                <el-form-item label="课题组" prop='groupId'>
                  <!-- <el-select placeholder="请选择课题组" v-model="formDatas.groupId">
                    <el-option v-for="(item, index) in classData" :key="index" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select> -->
                  <el-input disabled placeholder="课题组" v-model="projectTeamGroupNames"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label="预约时间" prop='reservationTime'>
                  <el-input @click.native='selectTime' readonly placeholder="请选择预约时间"
                    v-model="formDatas.reservationTime"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label="预约日期">
                  <el-input disabled placeholder="选择预约时间带出" v-model="reservationDate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label="计费时长">
                  <el-input disabled placeholder="根据预约时间计算" v-model="formDatas.reservationDuration"></el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="billingMethod != '1'" :span='12'>
                <el-form-item label="计费件数" prop='reservationCount'>
                  <el-input placeholder="请输入计费件数" v-model="formDatas.reservationCount"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span='24'>
                <el-form-item label="预约备注" label-width="15%">
                  <el-input type='textarea' placeholder="请填写预约备注" :rows='3' v-model="formDatas.remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="height: 50px;">
            <el-button style="float: right;" type="primary" @click='submitLast'>提交</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <selecttime v-if="showSelect" :showSelect='showSelect' @cancel="showSelect = false;" :selectListcopy='selectList'
      @submit='detailsubmitData' :eqId='eqId' :allowCrossDay="formData.allowCrossDay" />
  </div>
</template>
<script>
import admissionExamination from './components/admissionExamination.vue'
import eqadmissionExamination from './components/eqadmissionExamination.vue'
import selecttime from './dialog/selectpointTime.vue'
const { APIURl } = require('@/utils/apiUrl')
export default {
  components: {
    selecttime, admissionExamination, eqadmissionExamination
  },
  data() {
    return {
      showSelect: false,
      formData: {
      },
      formDatas: {
        groupId: '',
        reservationTime: '',
        reservationEndTime: '',
        reservationStartTime: '',

      },
      classData: [],
      rules: {
        // groupId: [
        //   { required: true, message: '请选择课题组', trigger: ["blur", 'change'] },
        // ],
        reservationTime: [
          { required: true, message: '请选择预约时间', trigger: ["blur", 'change'] },
        ],
        reservationCount: [
          { required: true, message: '请输入计费件数', trigger: ["blur"] },
        ],
      },
      reservationDate: '',
      eqId: '',
      selectList: [],
      baseurl: '',
      showurlList: [],
      activeIndex: '',
      eqExamination_show: false,
      examination_pass: '',
      eqmentexamination_pass: '',
      examinationData: '',
      eqexaminationData: '',
      billingMethod: '',
      projectTeamGroupNames: '',
      examination_show: false
    }
  },
  methods: {
    init() {
      this.eqId = this.$route.query.id
      this.billingMethod = this.$route.query.billingMethod
      this.baseurl = APIURl
      this.projectTeamGroupNames = this.$store.getters.userInfo.projectTeamGroupNames
      this.formDatas.groupId = this.$store.getters.userInfo.projectTeamGroupIds
      this.$net(`/v1/userClient/home/selectHomeEquipmentById/${this.eqId}`, 'get').then(res => {
        this.formData = res.data
        this.showurlList[0] = this.formData.thumbnailPath ? APIURl + '/' + this.formData.thumbnailPath : ''
      })
      this.$net(`/sdau/userClient/appraisal/queryAdmissionExamPaper`, 'get').then(resb => {
        this.examination_pass = resb.data.pass
        this.examinationData = resb.data
        this.examination_show = resb.data.open ? true : false
        this.$net(`/sdau/userClient/appraisal/queryEquipmentExamPaper/${this.eqId}`, 'get').then(res => {
          this.eqexaminationData = res.data
          this.eqmentexamination_pass = res.data.pass
          this.eqExamination_show = res.data.open ? true : false
          this.activeIndex = this.examination_show ? !this.examination_pass ? '1' : this.eqExamination_show ? this.eqmentexamination_pass ? '3' : '2' : '3' : this.eqExamination_show ? this.eqmentexamination_pass ? '3' : '2' : '3'
        })
      })
    },
    handleClick(activeName, oldActiveName) {
      if (oldActiveName == 1) {
        if (!this.examination_pass && (activeName == 2 || activeName == 3) && this.examination_show) {
          this.$message({
            type: 'warning',
            message: '您还未通过准入考试'
          })
          return false
        }
        if (!this.eqmentexamination_pass && activeName == 3 && this.eqExamination_show) {
          this.$message({
            type: 'warning',
            message: '您还未通过专属设备考试'
          })
          return false
        }
      }
      if (oldActiveName == 2 && activeName == 3) {
        if (!this.eqmentexamination_pass) {
          this.$message({
            type: 'warning',
            message: '您还未通过设备专属考试'
          })
          return false
        }
      }
    },
    selectTime() {
      this.showSelect = true
    },
    detailsubmitData(selectList, minute) {
      this.selectList = selectList
      this.$set(this.formDatas, 'equipmentId', this.eqId)
      this.reservationDate = selectList[0].date
      this.formDatas.reservationStartTime = selectList[0].date + ' ' + selectList[0].time.split('~')[0] + ':00'
      this.formDatas.reservationEndTime = selectList[selectList.length - 1].date + ' ' + selectList[selectList.length - 1].time.split('~')[1] + ':00'
      this.formDatas.reservationDuration = minute
      this.formDatas.reservationTime = this.formDatas.reservationStartTime + '~' + this.formDatas.reservationEndTime
    },
    submitLast() {
      this.$refs["formDatas"].validate((valid) => {
        if (valid) {
          this.formDatas.reservationCount = Number(this.formDatas.reservationCount)
          this.$net(`/sdau/deviceReservation/submit`, 'post', this.formDatas).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '预约成功'
              })
              this.$router.push({ path: '/eqment' })
            }
          })
        }
      })

    },
    toHome() {
      this.$router.push({ path: '/' })
    },
    toEqment() {
      this.$router.push({ path: '/EqMent' })
    },
  },
  created() {
    this.init()
  },
}
</script>
<style lang="scss" scoped>
.box {
  padding: 0 416px 32px 416px;
}

.card_header {
  padding: 19px 0 19px 32px;
  font-size: 18px;
  font-family: Source Han Sans SC;
  font-weight: bold;
  color: #333333;
  border: 1px solid #d7dce0;
  border-bottom: none;
  background: #f6f6f6;
}

.appointment_card {
  padding: 0 32px 32px 32px;
  border: 1px solid #d7dce0;

  .samalltitle {
    margin-top: 32px;
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #333333;
    padding-left: 12px;
  }

  .titleBorder {
    border-left: 4px #188335 solid;
  }
}

::v-deep.longForm {
  .el-form-item__content {
    width: 90%;

    .el-select {
      width: 100%;
    }
  }
}

.el-select-dropdown__item {
  width: 100%;
}
</style>
